import { getTierIds } from '../../../../utils/getTierIds'
import type { FormValues } from '../../types'

export const getCommonFieldsPayload = (values: FormValues) => {
  const tiers = getTierIds(values.tierIds)

  const getLiveAt = () => {
    if (values.mode === 'create') {
      return values.liveAt ? values.liveAt.toISOString() : new Date().toISOString()
    }

    if (values.mode === 'update' && values.liveAt) {
      return values.liveAt ? values.liveAt.toISOString() : undefined
    }
  }

  return {
    attributes: {
      core: {
        title: values.title,
        description: values.description,
        liveAt: getLiveAt(),
        tags: values.tags,
      },
    },
    access: {
      type: values.access,
      tiers,
    },
    notifications: {
      enabled: !!values.notifyMembers,
    },
  }
}
